import React, { useEffect, useRef, useState } from "react";
import {
  Grid,
  Button,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  TableCell,
  TableRow,
  Table,
  CircularProgress,
  Box,
  Divider,
} from "@mui/material";
import "../../../Sass/Common.scss";
import { makeStyles } from "@mui/styles";
import { PrimaryDialogTitle } from "../../../Components/Common/Dialog/DialogComponents";
import moment from "moment";
import { capitalizeFirstLetter } from "../../../utils/generalUtils";
import ReactToPrint from "react-to-print";
import PrimaryIcon from "../../../Components/Common/PrimaryIcon";
import { ReactComponent as ModalCloseIcon } from "../../../Assets/Icons/PharmsmartIcon/ModalCloseIcon.svg";
import { ReactComponent as RepeatSmart } from "../../../Assets/Logo/RepeatSmart.svg";
import { ReactComponent as PatientIcon } from "../../../Assets/Icons/PatientIcon.svg";
import { ReactComponent as CalenderPatient } from "../../../Assets/Icons/CalenderPatient.svg";
import useViewport from "../../../Hooks/useViewport";
import PageLoading from "../PageLoading";
import { useSelector } from "react-redux";
const useStyle = makeStyles((theme) => ({
  rsViewOrderMain: {
    alignItems: "center",
    justifyContent: "center",
    "&>div": {
      paddingTop: "20px",
      textAlign: "center",
      "@media print": {
        marginTop: "50px",
      },
    },
  },
  rsViewRxcolum: {
    marginTop: "20px",
    "&> div": {
      display: "flex",
      marginBottom: "10px",
      whiteSpace: "nowrap",
      justifyContent: "flex-end",
      "&>p": {
        fontSize: "16px",
        color: "black",
      },
    },
  },
  cellStyle: {
    width: "320px",
    textAlign: "start",
    display: "flex",
    whiteSpace: "normal",
    justifyContent: "start",
    alignItems: "start",
  },
  cellStyleQTY: {
    width: "320px",
    textAlign: "start",
    display: "flex",
    whiteSpace: "normal",
    justifyContent: "flex-end",
    // alignItems: "start",
    marginRight: "130px !important",
  },
  cellStyleRight: {
    width: "350px",
    whiteSpace: "nowrap",
    marginLeft: "15px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    "&>p": {
      color: "black",
      fontSize: "14px",
      fontWeight: "500",
    },
  },
  cellStyleRightOntity: {
    width: "100%",
    whiteSpace: "nowrap",
    marginLeft: "15px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "flex-end",
    "&>p": {
      color: "black",
      fontSize: "14px",
      fontWeight: "500",
    },
  },
  printBtn: {
    display: "flex",
    justifyContent: "right",
    alignItems: "center",
  },
  rsDialogContent: {
    padding: "20px 20px !important",
  },
  rsTitleContent: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  rsTitleContentColse: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "end",
  },
  rsPrintMainSection: {
    "@media print": {
      width: "96% !important",
      display: "block",
      margin: "0px 2% !important",
      paddingTop: "30px !important",
      paddingRight: "20px",
    },
  },
  rsOrderDescriptionCls: {
    display: "block !important",
    marginLeft: "20px !important",
    paddingTop: "30px !important",
    width: "auto !important",
    "&>p": {
      paddingBottom: "10px !important",
    },
  },
  rsTable: {
    borderWidth: "1px !important",
    borderColor: "#F2F2F2 !important",
    borderStyle: "solid !important",
    borderRadius: "7px !important",
  },
  rsTableRow: {
    border: "3px !important",
  },
  rsNameinline: {
    display: "flex",
  },
  rsLoading: {
    display: "flex",
    justifyContent: "center",
  },
  rsOrderToAndFrom: {
    margin: "20px",
    marginBottom: "30px",
    // [theme.breakpoints.down("1000")]: {
    //   width: " calc(100% + 175px) !important",
    // },
    // [theme.breakpoints.down("550")]: {
    //   width: " calc(100% + 58%) !important",
    // },
    // [theme.breakpoints.down("500")]: {
    //   width: " calc(100% + 62%) !important",
    // },
    // [theme.breakpoints.down("480")]: {
    //   width: " calc(100% + 85%) !important",
    // },
    // [theme.breakpoints.down("430")]: {
    //   width: " calc(100% + 95%) !important",
    // },
    // [theme.breakpoints.down("420")]: {
    //   width: " calc(100% + 97%) !important",
    // },
    // [theme.breakpoints.down("400")]: {
    //   width: " calc(100% + 115%) !important",
    // },
    // [theme.breakpoints.down("380")]: {
    //   width: " calc(100% + 121%) !important",
    // },
    "&>div": {
      display: "flex",
      justifyContent: "space-between",
      width: "100%",
      "&>div": {
        textAlign: "end",
        // color: "#5A6872",
      },
    },
    // margin: "20px !important",
  },
  rsPrescription: {
    marginLeft: "34px !important",
    color: "#262626 !important",
    fontWeight: "500 !important",
  },
  rsTextAlign: {
    display: "flex",
    "&>p": {
      color: "black !important",
    },
  },
  rsMainMedi: {
    width: "350px",
    textAlign: "start",
    display: "flex !important",
    whiteSpace: "normal",
    justifyContent: "start",
    alignItems: "start",
    borderBottom: "0px !important",
  },
  rsMainAddress: {
    color: "black !important",
  },
  patientContainer: {
    display: "flex",
    flexDirection: "row",
    marginBottom: "30px",
    marginLeft: "10px",
  },
  rowStyle: {
    display: "grid !important",
    gridTemplateColumns: "1fr 1fr !important",
    background: "#F2F2F2",
    justifyItems: "flex-start",
    height: "40px",
    alignContent: "center",
    borderTopLeftRadius: "7px",
    borderTopRightRadius: "7px",
  },
  bodyRowStyle: {
    display: "grid !important",
    gridTemplateColumns: "1fr 1fr !important",
    justifyItems: "flex-start",
    alignContent: "center",
    height: "auto",
    marginTop: "10px",
  },
  heading: {
    width: "350px",
    whiteSpace: "nowrap",
    marginLeft: "15px",
    "&>p": {
      fontWeight: "500",
      color: "black",
      fontSize: "18px",
    },
  },
  headingQuantity: {
    width: "100%",
    whiteSpace: "nowrap",
    // marginLeft: "15px",
    display: "flex",
    justifyContent: "space-between",
    paddingLeft: "291px",
    "&>p": {
      fontWeight: "500",
      color: "black",
      fontSize: "18px",
    },
  },
  Icon: {
    width: "250px",
    height: "64px",
    marginLeft: "10px",
    marginTop: "-10px",
    marginBottom: "5px",
  },
  closeIcon: {
    marginRight: "15px",
    marginTop: "15px",
  },
  pharmacyTitle: {
    fontSize: "16px !important",
    fontWeight: "700 !important",
    color: "black !important",
    width: "fit-content !important",
  },
  pharmacyAddress: {
    fontSize: "16px !important",
    width: "fit-content !important",
    color: "black !important",
  },
  divider: {
    background: "#5050502e !important",
    width: "99% !imporatant",
    marginLeft: "9px !important",
    marginTop: "10px !important",
    marginBottom: "10px !important",
  },
  patientText: {
    color: "#7BC044 !important",
    fontWeight: "500 !important",
  },
  patientSubText: {
    color: "black !important",
    fontWeight: "500 !important",
    marginLeft: "8px !important",
  },
  patientIcon: {
    marginRight: "8px",
  },
}));

const FaxDialog = (props) => {
  const classes = useStyle();
  const componentRef = useRef();
  const loginUserDetail = useSelector((state) => state.user);
  const {
    open,
    setOpen,
    body,
    phone,
    fax,
    setFax,
    setPhone,
    actionType,
    viewOrderData,
    setViewOrderData,
    collect,
    collectionViewRxAction,
    collectedUncollectedListShow,
    collectAndUncollectedViewRxDetails,
  } = props;
  let tempCollected = 0;
  let tempRemoved = 0;
  const handleClose = () => {
    setOpen(false);
    setFax(false);
    setPhone(false);
  };
  const { width } = useViewport();
  useEffect(() => {
    if (open && collect) {
      let payload = {
        type: collectedUncollectedListShow,
      };
      collectionViewRxAction(collectAndUncollectedViewRxDetails, payload);
    }
  }, [open]);
  useEffect(() => {
    if (open && body?.data) {
      let medications = [];
      let numberOfMedication = 0;
      let tempNumberOfMedication =
        body?.data?.number_of_medication || numberOfMedication;
      let tempData = {
        medication:
          medications.length > 0
            ? medications
            : body?.data?.patient_medications,
        surgeryName: body?.data?.surgery?.name,
        surgeryEmail: body?.data?.surgery?.email,
        dob: body?.data?.dob ? body?.data?.dob : "",
        name: body?.data?.name,
        last_name: body?.data?.last_name,
        medication_type: body?.data?.medication_type,
        number_of_medication: tempNumberOfMedication,
        medicationCollected: tempCollected,
        medicationRemoved: tempRemoved,
        medicationUncollected:
          tempNumberOfMedication - tempCollected - tempRemoved,
        phone: body?.data?.surgery?.phone,
        fax: body?.data?.surgery?.fax,
        surgeryAddress: body?.data?.surgery?.address,
      };

      setViewOrderData(tempData);
    }
  }, [body]);

  return (
    <>
      <Dialog
        open={open}
        maxWidth={"md"}
        onClose={() => handleClose()}
        BackdropProps={{
          classes: {
            root: "root",
          },
        }}
        sx={
          width < 1000
            ? {
              "& .MuiDialog-container": {
                "& .MuiPaper-root": {
                  width: "100%",
                  top: "20px !important",
                  maxWidth: "600px", // Set your width here
                },
              },
            }
            : width < 1100
              ? {
                "& .MuiDialog-container": {
                  "& .MuiPaper-root": {
                    width: "100%",
                    top: "20px !important",
                    maxWidth: "800px", // Set your width here
                  },
                },
              }
              : width < 1200
                ? {
                  "& .MuiDialog-container": {
                    "& .MuiPaper-root": {
                      width: "100%",
                      top: "20px !important",
                      // maxWidth: "1000px", // Set your width here
                    },
                  },
                }
                : {
                  "& .MuiDialog-container": {
                    "& .MuiPaper-root": {
                      top: "20px !important",
                      // maxWidth: "1000px", // Set your width here
                    },
                  },
                }
        }
        className="rsDialogMain"
      >
        <Box className={classes.rsTitleContentColse}>
          {/* <PrimaryIcon icon={RepeatSmart} className={classes.Icon} /> */}
          <PrimaryIcon
            className={classes.closeIcon}
            cursor="pointer"
            icon={ModalCloseIcon}
            onClick={() => handleClose()}
          />
        </Box>
        <DialogContent className={classes.rsDialogContent}>
          <Grid ref={componentRef} className={classes.rsPrintMainSection}>
            <Box className={classes.rsTitleContent}>
              <PrimaryIcon icon={RepeatSmart} className={classes.Icon} />
              {/* <PrimaryIcon
                className={classes.closeIcon}
                cursor="pointer"
                icon={ModalCloseIcon}
                onClick={() => handleClose()}
              /> */}
            </Box>
            {/* <Grid
              container
              columnSpacing={2.5}
              rowSpacing={3}
              className={classes.rsViewOrderMain}
            >
              <Grid item xs={8} sm={8} md={8} lg={8}>
                <Typography variant="h3" medium>
                  Prescription Order Request
                </Typography>
              </Grid>
            </Grid> */}

            <Grid
              container
              rowSpacing={1}
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
              className={classes.rsOrderToAndFrom}
            >
              {/* <Typography>To,</Typography> */}
              <Box>
                <Box
                  style={{
                    marginLeft: "34px",
                  }}
                >
                  <Typography className={classes.pharmacyTitle}>
                    {viewOrderData?.pharmacy_detail?.name
                      ? viewOrderData?.pharmacy_detail?.name
                      : body?.data?.pharmacy?.name
                        ? body?.data?.pharmacy?.name
                        : body?.data?.pharmacy_name?.name}
                  </Typography>

                  <Typography className={classes.pharmacyAddress}>
                    {viewOrderData?.pharmacy_detail?.address
                      ? viewOrderData?.pharmacy_detail?.address
                      : body?.data?.pharmacy?.address
                        ? body?.data?.pharmacy?.address
                        : body?.data?.pharmacy_name?.address
                          ? body?.data?.pharmacy_name?.address
                          : "-"}
                  </Typography>
                  <Box className={classes.rsTextAlign}>
                    <Typography>Email:&nbsp;</Typography>
                    <Typography className={classes.pharmacyAddress}>
                      {viewOrderData?.pharmacy_detail?.email
                        ? viewOrderData?.pharmacy_detail?.email
                        : body?.data?.pharmacy?.email
                          ? body?.data?.pharmacy?.email
                          : body?.data?.pharmacy_name?.email
                            ? body?.data?.pharmacy_name?.email
                            : "-"}
                    </Typography>
                  </Box>
                </Box>

                <Box>
                  <Typography className={classes.pharmacyTitle}>
                    {viewOrderData?.surgeryName}
                  </Typography>
                  {viewOrderData?.surgeryAddress ||
                    body?.data?.surgery_name?.address ||
                    (body?.data?.surgery?.address && (
                      <Typography
                        variant="h5"
                        className={classes.rsMainAddress}
                      >
                        {viewOrderData?.surgeryAddress
                          ? viewOrderData?.surgeryAddress
                          : body?.data?.surgery?.address
                            ? body?.data?.surgery?.address
                            : body?.data?.surgery_name?.address}
                      </Typography>
                    ))}
                  {phone && (
                    <Box className={classes.rsTextAlign}>
                      <Typography>Phone:&nbsp;</Typography>
                      <Typography>
                        {viewOrderData?.phone ? viewOrderData?.phone : "-"}
                      </Typography>
                    </Box>
                  )}
                  {fax && (
                    <Box className={classes.rsTextAlign}>
                      <Typography>Fax:&nbsp;</Typography>
                      <Typography>
                        {viewOrderData?.fax ? viewOrderData?.fax : "-"}
                      </Typography>
                    </Box>
                  )}
                </Box>
              </Box>
            </Grid>
            <Grid>
              <Grid
                container
                rowSpacing={1}
                columnSpacing={{ xs: 1, sm: 2, md: 3 }}
              >
                {/* <Typography>To,</Typography> */}
                <Typography className={classes.rsPrescription}>
                  Prescription Order Request
                </Typography>
              </Grid>
              <Divider className={classes.divider} />

              <Box className={classes.patientContainer}>
                <Box className={classes.cellStyle} semiBold variant="h4">
                  <Box className={classes.rsNameinline}>
                    <PrimaryIcon
                      className={classes.patientIcon}
                      cursor="pointer"
                      icon={PatientIcon}
                    />
                    <Typography className={classes.patientText}>
                      Patient name:&nbsp;
                    </Typography>
                    <Typography className={classes.patientSubText}>
                      {" "}
                      {capitalizeFirstLetter(viewOrderData?.name)}{" "}
                      {capitalizeFirstLetter(viewOrderData?.last_name)}
                    </Typography>
                  </Box>
                </Box>
                <Box className={classes.cellStyleRight}>
                  <Box className={classes.rsNameinline}>
                    <PrimaryIcon
                      className={classes.patientIcon}
                      cursor="pointer"
                      icon={CalenderPatient}
                    />
                    <Typography className={classes.patientText}>
                      DOB:&nbsp;
                    </Typography>

                    <Typography className={classes.patientSubText}>
                      {viewOrderData?.dob
                        ? moment(new Date(viewOrderData?.dob)).format(
                          "DD-MM-YYYY"
                        )
                        : "N / A "}{" "}
                    </Typography>
                  </Box>
                </Box>
              </Box>
              {body?.loading ? (
                <Box className={classes.rsLoading}>
                  <CircularProgress
                    className={classes.progress}
                    color="primary"
                    disableShrink
                  />
                </Box>
              ) : (
                <Grid className={classes.rsTable}>
                  <Box className={classes.rowStyle}>
                    <Box className={classes.heading}>
                      <Typography>Medication:&nbsp;</Typography>
                    </Box>
                    <Box className={classes.headingQuantity}>
                      <Typography>Quantity:&nbsp;</Typography>
                    </Box>
                  </Box>
                  {(viewOrderData?.medication_type === "specific" ||
                    viewOrderData?.medication_type === "unspecific" ||
                    viewOrderData?.medication_type == null) && (
                      <Box className={classes.bodyRowStyle}>
                        {viewOrderData?.medication?.map((item, index) => {
                          if (
                            item.action === true ||
                            actionType === "Chaseup" ||
                            actionType === "viewRx"
                          ) {
                            return (
                              <>
                                <Box className={classes.cellStyleRight}>
                                  <Typography className={classes.cellStyle}>
                                    {item?.drug_name
                                      ? item?.drug_name
                                      : item?.name}
                                  </Typography>
                                  <br />
                                </Box>
                                <Box className={classes.cellStyleRightOntity}>
                                  <Typography className={classes.cellStyleQTY}>
                                    {item?.quantity ? `${item?.quantity}` : "-"}
                                  </Typography>
                                  <br />
                                </Box>
                              </>
                            );
                          }
                        })}
                      </Box>
                    )}
                  {viewOrderData?.medication_type == "number" && (
                    <Box>
                      <Box>
                        {" "}
                        <Typography>No of medication ordered: </Typography>
                      </Box>
                      <Box>
                        <Typography>
                          {viewOrderData?.number_of_medication}
                          &nbsp;
                          {actionType === "Chaseup" || actionType === "viewRx"
                            ? viewOrderData?.medicationCollected === 0 ||
                              viewOrderData?.medicationRemoved === 0 ||
                              viewOrderData?.medicationUncollected === 0
                              ? " "
                              : `(${viewOrderData?.medicationCollected} Collected)  (${viewOrderData?.medicationRemoved} Removed)   (${viewOrderData?.medicationUncollected} Uncollected)`
                            : ""}{" "}
                        </Typography>{" "}
                      </Box>
                    </Box>
                  )}
                </Grid>
              )}
              <Grid className={classes.rsViewRxcolum}>
                <Grid item xs={6}>
                  <Typography sx={{ fontWeight: "500" }}>
                    Best regards,&nbsp;
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography>
                    {(viewOrderData?.created_by?.name &&
                      (window?.location?.pathname !== "/rx-collection" || window?.location?.pathname !== "/prescription-tracking")) ||
                      // orderPadDataData?.created_by?.name ||
                      loginUserDetail?.loginUserDetail?.data?.data?.name ||
                      "Admin"}{" "}
                    &nbsp;
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions style={{ padding: "20px" }}>
          {/* <Button variant="contained" onClick={() => handlePrint()}>
            Print
          </Button> */}
          <ReactToPrint
            trigger={() => (
              <Button variant="contained" className="BtnGreen">
                Print
              </Button>
            )}
            content={() => componentRef.current}
          />
          {/* <Button variant="outlined" onClick={() => handleClose()}>
            Cancel
          </Button> */}
        </DialogActions>
      </Dialog>
    </>
  );
};

export default FaxDialog;
